module.exports = __webpack_public_path__ + "img/maxmin.f5749a8f.svg";